export * from './lib/shared-tapestry-splash-screen';
